'use strict';

const $ = require('jquery');
const Modal = require('../modal');
const lang = require('../lang');
const Slide = require('./slide');
const template = require('../templates/sms-otp-slide.hbs');
import Keyboard from 'simple-keyboard';

var selectedInput;
var keyboardInstanceOTP;

module.exports = class extends Slide {
  constructor(context = {}) {
    context = $.extend({}, {title: lang.get('sms_otp_title') }, context);
    super(template, context);
    this._idletimer = _idletimer;
    this._otpDeliveredIntervalHandler = "";
    this.domEvents = {
      'click a[data-nav-next]': '_verifyOTP',
      'click a[data-nav-resend]' : '_sendOTP',
      //'mousemove': '_resetIdleTimer',
      'keydown':'_resetIdleTimer',
      'click': '_resetIdleTimer'
    };
    this.on('beforeEnter', this._sendOTP);
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
    this.on('beforeLeave', this._stopValidateSms);
    this.on('afterEnter', this._initiateVirtualKeyboardOTP);
    this.on('beforeLeave', this._removeVirtualKeyboardOTP);
  }

  reset() {

  }

  _sendOTP(){
    clearInterval(_otpintervalHandler);
    $("#resend_code_btn").hide();
    $("#otp-timer-span").html('');
    $("#message_failed").html('');
    $("#textdelivered").html('');
    $(".change_phone_btn").hide();
    $(".sv_text").html('');
    $("#sms_otp1").val('');
    $("#sms_otp2").val('');
    $("#sms_otp3").val('');
    $("#sms_otp4").val('');
    var mobileno = localStorage.getItem("phone_no");
   
    if(mobileno != '' && mobileno != undefined) {
      $.ajax({
        method: 'POST',
        url: 'slideshow/send_otp',
        data: $.extend({}, this._slideshow.getFormData(), {
          phone_no: mobileno,
          location_id: this._slideshow._location.id
        })
      }).done((response) => {
          var returnResonse = JSON.parse(response);
          if(returnResonse['status'] == 'success') {
            this._countdownOTPTimer();
            $(".sv_text").html(returnResonse['message'] +"<br/> Sent: " + returnResonse['sms_sent_time']);
            $(".sv_btns").hide();
            this._getOTPDeliveryStatus(mobileno);
            
          } else {
            $(".sv_text").html(returnResonse['message']);
            $("#message_failed").html("Message Failed ("+returnResonse['error_message'] +")");
            $(".sv_btns").show();
            $(".change_phone_btn").show();
            $(".resend_code_btn").show();
          }
        });
    } else {
        $(".sv_text").html(lang.get('phone_not_exist_msg') + mobileno);
        $(".sv_btns").show();
        $(".change_phone_btn").show();
        $(".resend_code_btn").show();
        $("#message_failed").html("Message Failed ("+lang.get('phone_not_exist_msg') +")");
    }
    return false;
  }

  // validates form, returns true if validated, false otherwise and displays an error message
  _validation() {
    const emptyFields = [];
    this.$el.find('input[required]').each(function () {
      const $this = $(this);
      if ($this.val().length === 0)
        emptyFields.push($this);
    });

    if (emptyFields.length !== 0) {
      new Modal({
        titleText: lang.get('form_modal_title'),
        bodyText: lang.get('form_modal_body'),
        submitBtnText: lang.get('form_modal_button'),
        onHidden: () => emptyFields[0].focus()
      });
      return false;
    }
    return true;
  }

  _verifyOTP(){
    var mobileno = localStorage.getItem("phone_no");
    var digit1 = $("#sms_otp1").val();
    var digit2 = $("#sms_otp2").val();
    var digit3 = $("#sms_otp3").val();
    var digit4 = $("#sms_otp4").val();
    var otp = digit1.toString()+digit2.toString()+digit3.toString()+digit4.toString();
    if(mobileno != '' && mobileno != undefined) {
      var flag = '';
      $.ajax({
        method: 'POST',
        async: false,
        url: 'slideshow/verify_otp',
        data: $.extend({}, this._slideshow.getFormData(), {
        phone_no: mobileno,
        otp: otp
        }),
        success:function (response){
          flag = JSON.parse(response).result;
        },
      });
      if(flag === 1){
        clearInterval(_otpintervalHandler);
        clearInterval(_idleintervalHandler);
        clearInterval(this._otpDeliveredIntervalHandler);
        _idletimer = _mainidletimer;
        this._slideshow.navNext();
      } else {
         new Modal({
          titleText: lang.get('sms_alert'),
          bodyText: lang.get('otp_matching_error'),
          submitBtnText: lang.get('form_modal_button'),
        });
        return false;
      }
    } else {
      return true;
    }
    
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    _idletimer = _mainidletimer;
  }
  _countdown() {
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    _idleintervalHandler = setInterval(() => {
      _idletimer -= 1;
      if(_idletimer <= 30){
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }

  _stopIdleTimer(){
    if(_idleintervalHandler != undefined){
      clearInterval(_idleintervalHandler);
    }
  }

  _countdownOTPTimer() {
    $("#otp-timer-span").html();
    $("#otp-resend-link").attr("href","#");
    var _otpidletimer = _otp_resend_timer;
    _otpintervalHandler = setInterval(() => {
      _otpidletimer -= 1;
      if (_otpidletimer === 0) {
        $("#otp-timer-span").html('<a href="#" data-nav-resend tabindex="-1" >'+lang.get('resend_otp')+'</a>');
        clearInterval(_otpintervalHandler);
      }
    }, 1000);
  }

  _getOTPDeliveryStatus(mobile_no) {
    var _otpDeliveredIdleTimer = 60;
    this._otpDeliveredIntervalHandler = setInterval(() => {
      _otpDeliveredIdleTimer -= 1;
      $.ajax({
        method: 'POST',
        url: 'slideshow/validate-sms-status',
        data: $.extend({}, this._slideshow.getFormData(), {
        phone_no: mobile_no
        })
      }).done((response) => {
         var returnResonse = response;
          if(returnResonse['status'] == 'success') {
            if(returnResonse['delivery_status'] == 'Delivered') {
              $("#textdelivered").html("Delivered: " + returnResonse.delivered_time);
              clearInterval(this._otpDeliveredIntervalHandler);
            }
          }
        });
      // Stop the ajax call if it calls for 50 times
      if (_otpDeliveredIdleTimer === 0) {
        clearInterval(this._otpDeliveredIntervalHandler);
      }
    }, 5000);
  }

  _stopValidateSms() {
    if(this._otpDeliveredIntervalHandler != undefined) {
      clearInterval(this._otpDeliveredIntervalHandler);
    }
  }

  _initiateVirtualKeyboardOTP() {
    $("#virtualKeyboardForm").removeClass("simple-keyboard");
    $("#virtualKeyboardSlotTimeBooking").removeClass("simple-keyboard");
    $("#virtualKeyboardOTP").addClass("simple-keyboard");
    function onDocumentClick(event) {
      // Get the active element
      const activeElement = document.activeElement;
      if (event.target.classList.contains('form-control')) {
        // If the clicked target is a different form control, focus it
        if (activeElement !== event.target) {
          event.target.focus();  // Manually focus the target
        }
        return; // Exit from the function early as there's no need to process other conditions
      }

      // Check if the clicked target is not a form control and not part of the simple-keyboard
      if (!event.target.classList.contains('form-control') && !$(event.target).closest(".simple-keyboard").length) {
        // If the active element is a form control, then blur it to hide keyboard
        if (activeElement && activeElement.classList.contains('form-control')) {
          activeElement.blur();
        }
      }
    }
          if (localStorage.getItem('virtualKeyboard') === 'true') {
        $(document).on('click touchstart', onDocumentClick);
        $('body').addClass('virtual-keyboard-active');


        const defaultTheme = "hg-theme-default";

        $(document).on('focus', '.form-control', function () {
          $(".simple-keyboard").show();
        });

        $(document).on('touchstart', '.form-control', function () {
          $(".simple-keyboard").show();
        });

        $(document).on('blur', '.form-control', function () {
          $(".simple-keyboard").hide();
        });

        if (keyboardInstanceOTP) {
          keyboardInstanceOTP.destroy(); // Replace with the actual method to destroy the keyboard if it exists
        }


        keyboardInstanceOTP = new Keyboard({
          onChange: input => onChangeOTP(input),
          theme: defaultTheme,
          layout: {
            'default': [
              '1 2 3',
              '4 5 6',
              '7 8 9',
              '+ 0 {bksp}'
            ]
          },
          display: {
            '{bksp}': '⌫',
            '{space}': ' '
          }
        });

        // Set the selectedInput to the first .form-control element by default
        let firstInput = document.querySelector('.form-control');
        if (firstInput) {
          selectedInput = `#${firstInput.id}`; // Assigning the variable defined at a higher scope
        }

        document.querySelectorAll(".form-control").forEach(input => {
          input.addEventListener("focus", onInputFocusOTP);
          input.addEventListener("touchstart", onInputFocusOTP); // Add this line
          input.addEventListener("input", onInputChangeOTP);
        });

        function onInputFocusOTP(event) {
          selectedInput = `#${event.target.id}`;
          const inputValue = document.querySelector(selectedInput).value;
          keyboardInstanceOTP.setInput(inputValue, event.target.id);
          keyboardInstanceOTP.setOptions({
              inputName: event.target.id
            });
        }


        function onInputChangeOTP(event) {
          keyboardInstanceOTP.setInput(event.target.value, event.target.id);

          let prevInputId = event.target.getAttribute('data-previous');
          if (event.target.value.length === 0 && prevInputId) {
            document.getElementById(prevInputId).focus();
          }
        }

        function onChangeOTP(input) {
          const inputElem = document.querySelector(selectedInput || ".input");
          inputElem.value = input;
          inputElem.dispatchEvent(new Event('input'));

          // Automatically focus on the next input if there is one
          let nextInputId = inputElem.getAttribute('data-next');
          if (inputElem.value.length >= 1 && nextInputId) {
            document.getElementById(nextInputId).focus();
          }
        }

      }
      $("#sms_otp1").focus();


  }
  _removeVirtualKeyboardOTP() {
    if(keyboardInstanceOTP !== undefined) keyboardInstanceOTP.destroy();
    $("#virtualKeyboardOTP").removeClass("simple-keyboard");
  }

};
